var React = require('react');

function StreamingWhite (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"streaminIconWhite-a","d":"M16 10V4H8v16h8v-7H8v-2h8v-1zm4 0h-2v4h2v-4zm0-2V4h-2v4h2zm-2 8v4h2v-4h-2zM4 14h2v-4H4v4zm0 2v4h2v-4H4zm0-8h2V4H4v4zm0 14H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"streaminIconWhite-b","fill":"#FFFFFF","key":0},React.createElement("use",{"xlinkHref":"#streaminIconWhite-a"})),React.createElement("use",{"fill":"#FFFFFF","xlinkHref":"#streaminIconWhite-a","key":1}),React.createElement("g",{"fill":"#FFFFFF","mask":"url(#streaminIconWhite-b)","key":2},React.createElement("path",{"d":"M0 0h24v24H0z"}))])]);
}

StreamingWhite.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StreamingWhite;

StreamingWhite.default = StreamingWhite;
